export const UA = navigator.userAgent || navigator.vendor || window.opera
export const isWebkit =
  /\b(iPad|iPhone|iPod)\b/.test(UA) &&
  /WebKit/.test(UA) &&
  !/Edge/.test(UA) &&
  !window.MSStream
export const isInstagram = UA.indexOf('Instagram') > -1

export const AppleInstagram = isInstagram && isWebkit
